import axios from "axios";
import { FETCH_PAYMENT_TYPES_FAILURE, FETCH_PAYMENT_TYPES_REQUEST, FETCH_PAYMENT_TYPES_SUCCESS, FETCH_PAYMENT_TYPES_SUCCESS_2, FETCH_PAYMENT_TYPE_FAILURE, FETCH_PAYMENT_TYPE_REQUEST, FETCH_PAYMENT_TYPE_SUCCESS } from "../../app/actions/actions";
import { ROUTES } from "../../config/routingUrl";
import { dureeDeVie, setWithExpiration } from "../../utils/storage/localvalueFuction";
import { localStorageData, localStorageKeys } from "../../utils/storage/localvalue";
import { baseurl } from "../../utils/url/baseurl";
import { saveDataToFile } from "../DataLocal";



// Create PaymentType
export const PaymentTypeCreate = (
    data,
    toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_PAYMENT_TYPE_REQUEST });
        await axios
            .post(
                `${baseurl.url}/api/v1/payment_types/`,
                data,
                {
                    headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                    }
                }
            )
            .then((response) => {
                toast.success("nouvel type de véhicule ajouté");
                dispatch({ type: FETCH_PAYMENT_TYPE_SUCCESS });
            })
            .catch((error) => {
                toast.error("type de véhicule non ajouté")
                dispatch({ type: FETCH_PAYMENT_TYPE_FAILURE, payload: error.message });
            });
    };
}



// update insurance 
export const PaymentTypeUpdateById = (idPaymentType, data, toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_PAYMENT_TYPE_REQUEST });
        await axios
            .put(`${baseurl.url}/api/v1/payment_types/update/${idPaymentType}`, data, {
                headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                }
            })
            .then((response) => {
                dispatch({ type: FETCH_PAYMENT_TYPE_SUCCESS });
                dispatch(fetchPaymentTypeById(idPaymentType));
                toast.success("Type de véhicle mis à jour");
            })
            .catch((error) => {
                dispatch({ type: FETCH_PAYMENT_TYPE_FAILURE, payload: error.message });
                toast.error("Véhicule non mis à jour")
            });
    };
}





// All insurance of plateforme
export function fetchPaymentTypesAll() {
    return async (dispatch) => {
        dispatch({ type: FETCH_PAYMENT_TYPES_REQUEST });
        await axios.get(`${baseurl.url}/api/v1/payment_types/get_payment_types`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            //console.log(response.data.data);
            dispatch({ type: FETCH_PAYMENT_TYPES_SUCCESS, payload: response.data.data });
            dispatch({ type: FETCH_PAYMENT_TYPES_SUCCESS_2, payload: response.data.data });
            saveDataToFile(response.data.data, localStorageData.PaymentTypes);
        })
            .catch((error) => {
                //console.log(error);
                dispatch({ type: FETCH_PAYMENT_TYPES_FAILURE, payload: error.message });
            });
    }
}


// get insurance by id 
export function fetchPaymentTypeById(idPaymentType) {
    return async (dispatch) => {
        dispatch({ type: FETCH_PAYMENT_TYPE_REQUEST });
        await axios.get(`${baseurl.url}/api/v1/payment_types/get_payment_type/${idPaymentType}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            //console.log(response.data.data);
            dispatch({ type: FETCH_PAYMENT_TYPE_SUCCESS, payload: response.data.data });
        })
            .catch((error) => {
                dispatch({ type: FETCH_PAYMENT_TYPE_FAILURE, payload: error.message })
                //console.log(error);
            });
    }
}

